
import { useState } from "react";
import { MdCheckBoxOutlineBlank, MdCheckBox } from "react-icons/md";
import TestTypeEditModal from "../modals/TestTypeEditModal";
import Enums from "@/enums";


export default function SiteTestAccessibilityTable(props: any) {
  const canEdit = props.adminPerms?.includes(Enums.ROLE_PERMS.EditSite)
    || props.adminPerms?.includes(Enums.ROLE_PERMS.CompanyAdmin)
    || props.adminPerms?.includes(Enums.ROLE_PERMS.SystemAdmin);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editTestType, setEditTestType] = useState(null);

  function handleEditClick(testType) {
    if (!canEdit) return;
    setEditTestType(testType);
    setEditModalOpen(true);
  }

  function handleModalClose() {
    setEditModalOpen(false);
    setEditTestType(null);
  }

  function handleModalSave(updatedTestType) {
    // Optionally update local data or trigger parent refresh
    if (props.updateData) props.updateData();
    handleModalClose();
  }

  // Track selected test type (dimension selection)
  const [selectedTestTypeId, setSelectedTestTypeId] = useState(null);

  function handleRowClick(ctt) {
    if (!canEdit) return;
    if (selectedTestTypeId === ctt.id) {
      handleEditClick(ctt);
    } else {
      setSelectedTestTypeId(ctt.id);
      // Optionally, trigger parent update if needed
      if (props.onTestTypeSelect) props.onTestTypeSelect(ctt);
    }
  }

  return (
    <div className="tableWrapper factTable horizontal">
      <table>
        <caption>
          <div className="title">{props.subEntityTypeName || "Site"} / Tests</div>
        </caption>
        <thead>
          <tr>
            <th>Test Type</th>
            <th>Access</th>
          </tr>
        </thead>
        <tbody>
          {props.companyTestTypes
            ? props.companyTestTypes.map((ctt) => {
              const stt = props.siteTestTypes.find(
                (stt) => stt.companyTestTypeId === ctt.id && stt.siteId === props.activeSite.id
              );
              const isSelected = selectedTestTypeId === ctt.id;
              return (
                <tr
                  key={"ctt" + ctt.id}
                  className={isSelected ? "selected" : ""}
                  onClick={() => handleRowClick(ctt)}
                  style={{ cursor: canEdit ? "pointer" : "default" }}
                >
                  <td>{ctt.name}</td>
                  <td
                    className="actions"
                    onClick={e => {
                      e.stopPropagation();
                      if (canEdit) props.toggleSiteTest(ctt.id);
                    }}
                  >
                    {stt ? (
                      <MdCheckBox className={`checkbox checked actionIcon${canEdit ? "" : " disabled"}`} />
                    ) : (
                      <MdCheckBoxOutlineBlank className={`checkbox unchecked actionIcon${canEdit ? "" : " disabled"}`} />
                    )}
                  </td>
                </tr>
              );
            })
            : null}
        </tbody>
      </table>
      <TestTypeEditModal
        isOpen={editModalOpen}
        onClose={handleModalClose}
        testType={editTestType}
        onSave={handleModalSave}
      />
    </div>
  );
}

